export default "__VITE_ASSET__DJt9Y7jJ__"